type PaymentSystemInfo = {
  commission?: number
  standard?: string
}

export const paymentSystemInfo: Record<string, PaymentSystemInfo> = {
  nagad_card: {
    commission: 0,
  },
  bkash_card: {
    commission: 0,
  },
  rocket_card: {
    commission: 0,
  },
  nowpayments_crypto: {
    standard: 'TRC20'
  },
}
